import { useDeleteAtm } from "./api/deleteAtm";
import { Button } from "reactstrap";


const DeleteAtm = ({handleCloseModal, atmId}: DeleteAtmProps)  => {
  
  const deleteAtmMutation = useDeleteAtm({ atmId});
  const handleSubmit = async (): Promise<void> => {
    deleteAtmMutation.mutateAsync({ 
      atmId: atmId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το ATM;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteAtmProps{
  atmId: number;
  handleCloseModal: () => void;
}

export default DeleteAtm;